module.exports = __webpack_public_path__ + "img/automatic.8ac2649b.svg";